/** Notifications from agents and files agents made (work tools, ADR-0091). */
export default {
  en: {
    notifications: {
      title: "Notifications",
      subtitle: "What agents told you or your teams: files they made, cases they opened, reminders. Notifications sent to a team are marked read for you only.",
      empty: "No notifications yet. When an agent tells you or your team something, it shows here and in the bell.",
      unreadOnly: "Unread only",
      markAll: "Mark all as read",
      markRead: "Mark as read",
      markedAll: "All notifications are marked as read",
      unread: "New",
      toYou: "To you",
      toTeam: "To everyone with the role {{role}}",
      from: "From {{agent}}",
      open: "Open",
      request: "What happened",
    },
    file: {
      title: "File from an agent",
      subtitle: "Files agents make are kept in the platform. Only people of your organisation cleared for the file's data level can open them.",
      name: "File",
      size: "Size",
      level: "Data level",
      made: "Made",
      download: "Download",
      downloaded: "{{name}} was downloaded",
      notFound: "This file no longer exists, or the link is wrong.",
      forbidden: "This file holds data above what you may see. Ask the person who sent you the link.",
      failed: "The file could not be opened. Try again in a moment.",
      kind: { pdf: "PDF document", xlsx: "Excel workbook", csv: "Spreadsheet (CSV)", other: "File" },
    },
  },
  ar: {
    notifications: {
      title: "الإشعارات",
      subtitle: "ما أبلغك به الوكلاء أو أبلغوا به فرقك: ملفات أنشؤوها وقضايا فتحوها وتذكيرات. الإشعار المرسل إلى فريق يُعلَّم كمقروء لك وحدك.",
      empty: "لا توجد إشعارات بعد. عندما يُبلغك وكيل أو يُبلغ فريقك بشيء، يظهر هنا وفي الجرس.",
      unreadOnly: "غير المقروءة فقط",
      markAll: "تعليم الكل كمقروء",
      markRead: "تعليم كمقروء",
      markedAll: "عُلّمت كل الإشعارات كمقروءة",
      unread: "جديد",
      toYou: "إليك",
      toTeam: "إلى كل من لديه الدور {{role}}",
      from: "من {{agent}}",
      open: "فتح",
      request: "ما الذي حدث",
    },
    file: {
      title: "ملف من وكيل",
      subtitle: "تُحفظ الملفات التي ينشئها الوكلاء في المنصة. ولا يفتحها إلا أشخاص من مؤسستك مصرّح لهم بمستوى بيانات الملف.",
      name: "الملف",
      size: "الحجم",
      level: "مستوى البيانات",
      made: "أُنشئ في",
      download: "تنزيل",
      downloaded: "تم تنزيل {{name}}",
      notFound: "لم يعد هذا الملف موجودًا، أو أن الرابط غير صحيح.",
      forbidden: "يحتوي هذا الملف على بيانات أعلى مما يُسمح لك برؤيته. اسأل الشخص الذي أرسل إليك الرابط.",
      failed: "تعذّر فتح الملف. حاول مرة أخرى بعد قليل.",
      kind: { pdf: "مستند PDF", xlsx: "مصنّف Excel", csv: "جدول بيانات (CSV)", other: "ملف" },
    },
  },
};
